import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, STRING, UUID, ITEM, INTEGER } from '@/plugins/sdk/fields'
import Team from '@/plugins/sdk/resources/Team'
import Location from '@/plugins/sdk/resources/Account/Location'

export default class extends Resource {
  static name = 'shippersetting'

  static get fields () {
    return {
      id: new UUID(),
      printer_type: new INTEGER(),
      printer_name: new STRING(),
      printer_margin: new INTEGER(),
      printer_darkness: new INTEGER(),
      show_rates: new BOOLEAN(),
      hide_pricing: new BOOLEAN(),
      dimensions_required: new BOOLEAN(),
      calculation_method: new BOOLEAN(),
      quoting_inclusive: new BOOLEAN(),
      send_despatch_emails: new BOOLEAN(),
      autosave_addressbook: new BOOLEAN(),
      allow_import: new BOOLEAN(),
      supplier_only: new BOOLEAN(),
      can_consign: new BOOLEAN(),
      costcentre_required: new BOOLEAN(),
      reference_unique: new BOOLEAN(),
      reference_required: new BOOLEAN(),
      show_only_users_cons: new BOOLEAN(),
      search_only_users_cons: new BOOLEAN(),
      show_only_users_imports: new BOOLEAN(),
      can_enter_volume: new BOOLEAN(),
      show_invoices: new BOOLEAN(),
      tracking_only: new BOOLEAN(),
      show_reports: new BOOLEAN(),
      consolidate_cons: new BOOLEAN(),
      lowest_cost_only: new BOOLEAN(),
      allow_third_party: new BOOLEAN(),
      barcode_scanning: new BOOLEAN(),
      default_special_instructions: new STRING(),
      shipper_settings_level: new INTEGER(),
      show_issues: new BOOLEAN(),
      team: new ITEM(Team),
      address: new ITEM(Location),
      user_def_service: new STRING(),
      bypass_cubic_limit: new BOOLEAN(),
      user_show_same_sender: new BOOLEAN(),
      user_no_dashboard: new BOOLEAN(),
      user_reqinternalref: new BOOLEAN(),
      user_reqsignature: new BOOLEAN(),
      user_quote_ref_req: new BOOLEAN(),
      user_assign_consignment: new BOOLEAN(),
      default_residential: new BOOLEAN(),
      google_address_search: new BOOLEAN(),
      nzpost_address_search: new BOOLEAN(),
      user_manifest: new BOOLEAN(),
      reconciliation_enabled: new BOOLEAN(),
      print_breaker_label: new BOOLEAN(),
      notification_settings: new STRING(),
      justify_manual_carrier_overrides: new BOOLEAN()
    }
  }
}
